import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    formSectionHeader: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
            alignItems: 'flex-start',
            flexDirection: 'column'
        }
    },
    formSectionHeading: {
        fontWeight: 500
    },
    formSectionContent: {
        marginTop: 20,
    },
    editAddressLink: {
        padding: '0px'
    },
    formSectionInput: {
        marginBottom: 25,
        width: '100%',
        '@media(max-width: 480px)': {
            marginBottom: 20,
        },
        '&:last-child': {
            marginBottom: 0
        }
    },
    summaryContent: {
        backgroundColor: '#F5F5F5',
        display: 'block',
        marginTop: 25,
        padding: 30,
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            padding: 15
        }
    },
    summaryItem: {
        marginBottom: 30,
        '&:last-child': {
            marginBottom: 0
        },
        [theme.breakpoints.down('md')]: {
            marginBottom: 10,
            width: 'auto'
        }
    },
    summaryItemValue: {
        color: '#4A4A4A',
        display: 'block',
        fontSize: 16,
        fontWeight: 500,
        marginRight: 20,
        wordBreak: 'break-word',
        fontFamily: 'CircularStd',
        lineHeight: '1.5'
    },
    itemIcon: {
        height: 18,
        marginRight: 5,
        position: 'relative',
        top: '4px',
    }
});